import { retrieveLaunchParams } from '@tma.js/sdk-react';

import { env } from '@/env';
import type { LimuloOpenGameTennisClash } from '@/lib/limulo/openGame';

/**
 * Tennis Clash per QUESTA build e QUESTA piattaforma, per `openGameTargetOf`: il flag
 * (`VITE_FEATURE_TENNIS_CLASH_ENABLED`) e la `tgWebAppPlatform` con cui Telegram ha lanciato la mini app.
 * Una definizione sola per i due posti che offrono il gesto: il bottone unico dell'incontro e la barra
 * dell'azione persistente (come `servizioTavoliDellaBuild`).
 *
 * ⚠️ La piattaforma si legge SOLO a flag acceso: spento, niente lettura dei launch params e niente
 * cambio per nessun chiamante di prima. ⚠️ Fuori da Telegram (o se la lettura fallisce) e' `null`, e
 * `null` non e' un telefono: nessun bottone.
 */
export const tennisClashDellaBuild = (): LimuloOpenGameTennisClash => {
  if (!env.featureTennisClashEnabled) return { enabled: false, platform: null };
  try {
    return { enabled: true, platform: retrieveLaunchParams().tgWebAppPlatform ?? null };
  } catch {
    return { enabled: true, platform: null };
  }
};
